import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility per combinare classi Tailwind in modo sicuro
 * Usa clsx per la logica condizionale e twMerge per risolvere conflitti
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
